export default __webpack_public_path__ + "static/media/transferred.7f300ebf.png";